import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Sparkles, Crown, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

/**
 * Upgrade modal shown when a Free user tries to use a premium-only feature.
 * Props:
 *   open: bool
 *   onClose(): void
 *   feature: 'image' | 'video'
 */
export default function UpgradeDialog({ open, onClose, feature = 'image' }) {
  const copy = feature === 'video'
    ? { title: 'Unlock Jixxeo AI Video Creation', sub: 'Bring your ideas to life with Jixxeo AI Video.', line: 'Video creation is available with a paid Jixxeo AI subscription.' }
    : { title: 'Unlock Jixxeo AI Image Creation', sub: 'Create amazing images with Jixxeo AI.',           line: 'Image creation is available with a paid Jixxeo AI subscription.' };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass border-violet-500/40 max-w-sm overflow-hidden" data-testid="upgrade-dialog">
        <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-violet-500/30 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 w-48 h-48 rounded-full bg-cyan-500/20 blur-3xl pointer-events-none" />
        <DialogHeader>
          <div className="w-14 h-14 rounded-2xl gradient-brand mx-auto flex items-center justify-center shadow-xl shadow-violet-500/40 mb-2">
            <Lock className="w-7 h-7 text-white" />
          </div>
          <DialogTitle className="font-display text-xl text-center">{copy.title}</DialogTitle>
        </DialogHeader>
        <p className="text-center text-slate-300 text-sm">{copy.sub}</p>
        <p className="text-center text-slate-400 text-xs mb-2">{copy.line}</p>
        <div className="space-y-2 bg-white/5 rounded-xl p-3 border border-white/10">
          <div className="flex items-center gap-2 text-sm"><Crown className="w-4 h-4 text-amber-300" /> <span><strong>Premium</strong> — AI Image + AI Video + bonus JXP</span></div>
          <div className="flex items-center gap-2 text-xs text-slate-400"><Sparkles className="w-3.5 h-3.5 text-violet-300" /> <span>Starts at $9.99/mo. Cancel anytime.</span></div>
        </div>
        <div className="flex gap-2">
          <Button data-testid="upgrade-dialog-close" variant="outline" onClick={onClose} className="flex-1 border-white/15">Not now</Button>
          <Link to="/subscriptions" className="flex-1" onClick={onClose}>
            <Button data-testid="upgrade-dialog-cta" className="w-full gradient-brand text-white shadow-lg shadow-violet-500/30">
              View Plans
            </Button>
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
}
